export * from '@primeuix/themes/lara/overlaybadge';
export { default } from '@primeuix/themes/lara/overlaybadge';
